import React from 'react';
import { privacyPolicy } from '../data/privacyPolicy';
import Header from './Header';

function PrivacyPolicyPage({ onClose, user, userName, userPhone, onOpenOrders, onOpenAddresses, onOpenCart, cartCount, onLogout, onHelp }) {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      height: '100dvh',
      background: 'var(--bg-primary)',
      overflow: 'hidden'
    }}>
      <Header
        showSearch={false}
        isSignedIn={Boolean(user)}
        userName={userName}
        userPhone={userPhone}
        onLogoClick={null}
        onOpenOrders={onOpenOrders}
        onOpenAddresses={onOpenAddresses}
        onOpenCart={onOpenCart}
        cartCount={cartCount}
        onLogout={onLogout}
        onHelp={onHelp}
        showBackButton={true}
        onBackClick={onClose}
      />

      {/* Content */}
      <div style={{
        flex: 1,
        overflowY: 'auto',
        WebkitOverflowScrolling: 'touch',
        padding: '20px',
      }}>
        {/* Last Updated */}
        <div style={{
          background: 'var(--success-bg)',
          border: '1px solid var(--success)',
          borderRadius: '12px',
          padding: '12px 16px',
          marginBottom: '24px',
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
        }}>
          <span style={{ fontSize: '20px' }}>🔒</span>
          <div>
            <div style={{ fontSize: '13px', fontWeight: '600', color: 'var(--success-dark)' }}>
              Your Privacy Matters
            </div>
            <div style={{ fontSize: '12px', color: 'var(--text-muted)', marginTop: '2px' }}>
              Last Updated: {privacyPolicy.lastUpdated}
            </div>
          </div>
        </div>

        {/* Company Info */}
        <div style={{
          background: 'white',
          borderRadius: '16px',
          padding: '20px',
          marginBottom: '24px',
          border: '1px solid var(--border-light)',
          boxShadow: 'var(--shadow-sm)',
        }}>
          <h2 style={{
            margin: '0 0 12px 0',
            fontSize: '18px',
            fontWeight: '700',
            color: 'var(--text-primary)',
          }}>
            {privacyPolicy.companyName}
          </h2>
          <p style={{
            margin: 0,
            fontSize: '14px',
            color: 'var(--text-secondary)',
            lineHeight: '1.6',
          }}>
            {privacyPolicy.companyAddress}
          </p>
        </div>

        {/* Sections */}
        {privacyPolicy.sections.map((section, index) => (
          <div
            key={index}
            style={{
              background: 'white',
              borderRadius: '16px',
              padding: '20px',
              marginBottom: '16px',
              border: '1px solid var(--border-light)',
              boxShadow: 'var(--shadow-sm)',
            }}
          >
            <h3 style={{
              margin: '0 0 12px 0',
              fontSize: '16px',
              fontWeight: '700',
              color: 'var(--primary)',
            }}>
              {section.title}
            </h3>
            <div style={{
              fontSize: '14px',
              color: 'var(--text-secondary)',
              lineHeight: '1.7',
              whiteSpace: 'pre-line',
            }}>
              {section.content}
            </div>
          </div>
        ))}

        {/* Footer Note */}
        <div style={{
          background: 'var(--success-bg)',
          borderRadius: '12px',
          padding: '16px',
          marginTop: '24px',
          marginBottom: '20px',
          textAlign: 'center',
        }}>
          <p style={{
            margin: 0,
            fontSize: '13px',
            color: 'var(--success-dark)',
            lineHeight: '1.6',
          }}>
            We are committed to protecting your privacy and personal information.
            <br />
            Your data is secure with us.
          </p>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicyPage;

// Made with Bob
